<script context="module">
  import {getError} from '../global'
  let error = getError()
</script>
<script>
  import Header from './Header.svelte'
  import Headline from './partials/Headline.svelte'
  import Fieldset from './partials/Fieldset.svelte'
  import Footer from './partials/Footer.svelte'
  import Button from './partials/Button.svelte'

  let password = "password", visible = ' h-0 overflow-hidden'
  let supervisors = ['mwilliamson@bluewatertech.com','bwadmin@pangeaoneness.com', 'alorenz@bluewatertech.com']
  
  export function setVisible(email) {
    console.log(supervisors)
    visible = supervisors.indexOf(email) > -1 ? '' : ' h-0 overflow-hidden'
  }

</script>
<Header use_nav={false}/>
<div class="max-w-xl 2xl:max-w-2xl w-full space-y-4 md:space-y-6">
  <Headline h1={['Welcome to', 'Pangea Oneness']} iStyle="w-full mx-auto"/>
  <legend class="w-full mx-auto text-white">
    <p class="font-body text-sm sm:text-base 2xl:text-lg">Please enter your email to access the inspiration behind our journey.</p>
    {#if error}
    <p class="mt-2 bg-poppy text-xs p-1">{error}</p>
    {/if}
  </legend>
  <input type="hidden" name="remember" value="true">
  <Fieldset id="email" slug="Email" dStyle="w-full mx-auto" error={error} callback={setVisible}/>
  <Fieldset id="password" slug="Password" dStyle="w-full mx-auto{visible}" error={error}
   type="password" value={password}/>
  <nav class="max-w-xl 2xl:max-w-2xl w-full mx-auto">
    <Button slug="submit"/>
  </nav>
  <p class="w-full mx-auto text-white font-body text-xs sm:text-sm lg:text-base">
    For access to the Pangea Oneness Trend Show + Materials, contact Catherine Ciftci: <a class="font-bold hover:text-poppy focus:text-poppy" href="mailto:EVogas@pangeamade.com">cciftci@pangeamade.com</a>
  </p>
</div>
<Footer/>